/* eslint-disable @typescript-eslint/indent */
import React, { useEffect, useState } from 'react';
import { MenuItemType } from 'utility/enumerations';
import { envConfig } from 'utility/env_config';
import { MobileMenu } from './mobile_menu';

interface MobileHeaderProps {
  authenticated: Boolean,
  user: any
}

export const MobileHeader = (props : MobileHeaderProps) => {
  const [mobileMenuItems, setMobileMenuItems] = useState([]);

  useEffect(() => {
    const getMobileMenuItems = () => {
      const home = {
        text: 'Home',
        type: MenuItemType.Navigation,
        route: '/',
        icon: 'home',
        visible: true
      };
      const login = {
        text: 'Login',
        type: MenuItemType.Navigation,
        route: '/login',
        icon: 'sign-in-alt',
        visible: true
      };

      if (!props.authenticated) {
        return [home, login];
      }

      const mobileMenu = props.user?.menuNavigationDtos;

      if (!mobileMenu) {
        return [];
      }

    const items = [];

    mobileMenu.forEach((menuItem) => {
      if (menuItem.childMenuNavigationDtos !== undefined && menuItem.childMenuNavigationDtos.length) {
        items.push({
          id: menuItem.menuItemPermissionId,
          text: menuItem.text,
          icon: menuItem.icon,
          type: MenuItemType.Navigation,
          route: menuItem.route,
          visible: true,
          parentExpanded: true
        });
        menuItem.childMenuNavigationDtos.forEach((child) => {
            items.push({
              id: child.menuItemPermissionId,
              parentId: child.parentMenuItemPermissionId,
              text: child.text,
              icon: child.icon,
              type: child.Navigation,
              route: child.route,
              visible: false
            });
          });
      } else {
        items.push({
          id: menuItem.menuItemPermissionId,
          text: menuItem.text,
          icon: menuItem.icon,
          type: MenuItemType.Navigation,
          route: menuItem.route,
          visible: true
        });
      }
    });

    if (envConfig.enableDevLinks) {
      const sandbox = {
        text: 'Sandbox',
        type: MenuItemType.Navigation,
        route: '/sandbox',
        icon: 'cubes',
        visible: true
      };

    const variables = {
      text: 'Vars',
      type: MenuItemType.Navigation,
      route: '/vars',
      icon: 'cogs',
      visible: true
    };

    items.splice(0, 0, sandbox);
    items.splice(0, 0, variables);
    }

    const logout = {
      text: 'Log Out',
      icon: 'sign-out-alt',
      type: MenuItemType.Navigation,
      route: '/logout',
      visible: true
    };

    items.push(logout);

    return items;
    };

    setMobileMenuItems(getMobileMenuItems());
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.user?.menuNavigationDtos]);

  const onParentSelect = (parentId) => {
    setMobileMenuItems(mobileMenuItems.map((item) => {
      if (item.parentId === parentId) {
        return { ...item, visible: !item.visible };
      }
      if (item.parentExpanded !== undefined) {
        return { ...item, parentExpanded: !item.parentExpanded };
      }
      return item;
    }));
  };

  return (
    <header>
      <MobileMenu menuItems={mobileMenuItems} onParentSelect={onParentSelect} />
    </header>
  );
};
